module.exports = __webpack_public_path__ + "img/msp-pro-dark.810a75ba.svg";